import { render, staticRenderFns } from "./AverageTimeCallsReport.vue?vue&type=template&id=33d868aa&scoped=true"
import script from "./AverageTimeCallsReport.vue?vue&type=script&lang=js"
export * from "./AverageTimeCallsReport.vue?vue&type=script&lang=js"
import style0 from "./AverageTimeCallsReport.vue?vue&type=style&index=0&id=33d868aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d868aa",
  null
  
)

export default component.exports